import { VFC } from 'react'
import { renderIcon } from '../../../kuiper/src/utils'
import { AssetDownloadLink } from '../AssetDownloadLink'
import { ImageProxy } from '../ImageProxy'
import { VideoProxy } from '../VideoProxy'
import * as styles from './styles'
import type { AssetProps, AssetReference, ImageTransforms } from './types'

export type { AssetProps, AssetReference, ImageTransforms }

export const Asset: VFC<AssetProps> = ({
  alt,
  ariaLabel,
  ariaMode,
  assetReference,
  autoPlay = false,
  imageFit,
  onClick,
  onError,
  onLoad,
  preview = false,
  styleOverrides,
  transcodingUnavailable = false,
  transforms = {},
  videoLoop = false,
}) => {
  if (!assetReference || Object.keys(assetReference).length === 0) return null

  const ImageComponent = (
    <ImageProxy
      alt={alt}
      ariaLabel={ariaLabel}
      ariaMode={ariaMode}
      assetReference={assetReference}
      imageFit={imageFit}
      onClick={onClick}
      onError={onError}
      onLoad={onLoad}
      preview={preview}
      styleOverrides={styleOverrides}
      transcodingUnavailable={transcodingUnavailable}
      transforms={transforms}
    />
  )

  if (preview) return ImageComponent
  const fileName = assetReference.title || assetReference.filename

  switch (assetReference.asset_type) {
    case 'file':
    case 'image':
    case 'scraped_image':
    case 'url_preview_image':
      return ImageComponent
    case 'video':
      return (
        <VideoProxy
          assetReference={assetReference}
          autoPlay={autoPlay}
          videoLoop={videoLoop}
        />
      )
    default:
      return (
        <AssetDownloadLink
          assetReference={assetReference}
          styleOverrides={styles.link}
        >
          {renderIcon('download', {
            ariaLabel: 'Download',
            ariaMode: 'presentational',
          })}
          <span css={styles.downloadText}>Download {fileName}</span>
        </AssetDownloadLink>
      )
  }
}
